import { render, staticRenderFns } from "./diction.vue?vue&type=template&id=0b431c96&scoped=true"
import script from "./diction.vue?vue&type=script&lang=js"
export * from "./diction.vue?vue&type=script&lang=js"
import style0 from "./diction.vue?vue&type=style&index=0&id=0b431c96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b431c96",
  null
  
)

export default component.exports